import { SVGProps } from 'react';

const MultiMembersIcon = ({
  height = '24px',
  width = '24px',
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 31 31'
    {...props}
  >
    <g transform='translate(-40 -577)'>
      <g transform='translate(40 577)'>
        <g transform='translate(0 0.01)'>
          <path
            d='M3,22l.79-2.88c2.61-9.5,13.81-9.5,16.42,0L21,22'
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2.5'
          />
          <circle
            cx='5'
            cy='5'
            r='5'
            transform='translate(7 1.98)'
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='bevel'
            strokeWidth='2.5'
          />
        </g>
      </g>
      <g transform='translate(47 584)'>
        <g transform='translate(-2 -1.98)'>
          <path
            d='M3,22l.79-2.88c2.61-9.5,13.81-9.5,16.42,0L21,22'
            strokeLinecap='butt'
            strokeLinejoin='round'
            strokeWidth='2.5'
          />
          <circle
            cx='5'
            cy='5'
            r='5'
            transform='translate(7 1.98)'
            strokeLinecap='round'
            strokeLinejoin='bevel'
            strokeWidth='2.5'
          />
        </g>
      </g>
    </g>
  </svg>
);

export default MultiMembersIcon;
